<div
  #scroller
  class="autocomplete-content scroll-primary tw:overflow-y-auto"
  [style.max-height.px]="maxHeight"
  (scroll)="onScroll()"
>
  <span class="empty-result-message">
    <ng-content select="[empty-result-message]"></ng-content>
  </span>
  <ng-content select="[content]"></ng-content>
  @if (loadingMore()) {
    <div class="tw:flex tw:justify-center tw:py-2">
      <fr8bot-ui-loading [instant]="true" />
    </div>
  }
</div>
